/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const noserMemberDetailDtoRatePHPRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)(?:\\.\\d+)?$');


export const NoserMemberDetailDto = zod.object({
  "employeeNumber": zod.string().optional(),
  "lastName": zod.string().optional(),
  "firstName": zod.string().optional(),
  "middleName": zod.string().nullish(),
  "birthday": zod.coerce.date().nullish(),
  "gender": zod.string().nullish(),
  "contactNumber": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "barangay": zod.string().nullish(),
  "cityMunicipality": zod.string().nullish(),
  "province": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "approver1": zod.string().nullish(),
  "approver2": zod.string().nullish(),
  "dateHired": zod.coerce.date().nullish(),
  "position": zod.string().nullish(),
  "memberStatus": zod.string().nullish(),
  "memberClassification": zod.string().nullish(),
  "employmentStatus": zod.string().nullish(),
  "client": zod.string().nullish(),
  "contractStartDate": zod.coerce.date().nullish(),
  "contractEndDate": zod.coerce.date().nullish(),
  "leaveStartDate": zod.coerce.date().nullish(),
  "leaveEndDate": zod.coerce.date().nullish(),
  "estimatedDateOfDelivery": zod.coerce.date().nullish(),
  "lastWorkingDate": zod.coerce.date().nullish(),
  "payMode": zod.string().nullish(),
  "payType": zod.string().nullish(),
  "paycardType": zod.string().nullish(),
  "paycardNumber": zod.string().nullish(),
  "paycardStatus": zod.string().nullish(),
  "periodType": zod.string().nullish(),
  "ratePHP": zod.union([zod.number(),zod.string().regex(noserMemberDetailDtoRatePHPRegExpTwo)]).nullish(),
  "hmoName": zod.string().nullish(),
  "hmoNumber": zod.string().nullish(),
  "isNew": zod.boolean().optional(),
  "isActive": zod.boolean().optional()
});

export type NoserMemberDetailDto = zod.input<typeof NoserMemberDetailDto>;
export type NoserMemberDetailDtoOutput = zod.output<typeof NoserMemberDetailDto>;
